/** Normalize list payloads from useQuery (array or axios { data: { data: T[] } }). */
export function extractApiDataArray<T = unknown>(value: unknown): T[] {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  const record = value as { data?: unknown };
  if (Array.isArray(record.data)) return record.data as T[];
  const nested = record.data as { data?: unknown } | undefined;
  if (nested && Array.isArray(nested.data)) return nested.data as T[];
  return [];
}
